import { Clock, Loader, CheckCircle2 } from "lucide-react";

const STATUS_CONFIG = {
  open: { label: "Open", icon: Clock, className: "sup-badge--open" },
  in_progress: { label: "In Progress", icon: Loader, className: "sup-badge--progress" },
  resolved: { label: "Resolved", icon: CheckCircle2, className: "sup-badge--resolved" },
};

const SupStatusBadge = ({ status }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.open;
  const Icon = config.icon;

  return (
    <span className={`sup-badge ${config.className}`}>
      <Icon size={12} />
      {config.label}
    </span>
  );
};

export default SupStatusBadge;
